import { render, staticRenderFns } from "./safe-drawer-detail.vue?vue&type=template&id=beed2622&scoped=true"
import script from "./safe-drawer-detail.vue?vue&type=script&lang=js"
export * from "./safe-drawer-detail.vue?vue&type=script&lang=js"
import style0 from "./safe-drawer-detail.vue?vue&type=style&index=0&id=beed2622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beed2622",
  null
  
)

export default component.exports